import '../styles/Primitives.scss';

export default function DialogContent({ children, className = '', dividers = false, ...props }) {
  return <div className={`ui-dialog-content ${dividers ? 'ui-dialog-content--dividers' : ''} ${className}`.trim()} {...props}>{children}</div>;
}
